
































































import Vue from 'vue';
import checkout from '@/store/modules/checkout';
import Component from 'vue-class-component';
import Modal from '@/components/UI/Modal.vue';
import IconTrash from '@/components/SvgIcons/IconTrash.vue';
import ui from '@/store/modules/ui';

@Component({
    components: {
        Modal,
        IconTrash,
    },
})
export default class GiftCard extends Vue {
    private loading: boolean = false;
    private amount: any;
    private modalId = 'insertgiftcard';
    private applyError = '';

    private mounted() {
        if (checkout.giftCard.applied_credit) {
            this.amount = checkout.giftCard.applied_credit;
        }
    }

    private get applied(): boolean {
        return checkout.giftCard.applied;
    }

    private get giftcardCode(): string {
        return checkout.giftCard.code;
    }

    private set giftcardCode(code: string) {
        checkout.setGiftCardCode(code);
    }

    private get verified(): boolean {
      return checkout.giftCard.verified;
    }

    private set verified(verified: boolean) {
      checkout.setGiftCardVerified(verified);
    }

    private get getAvailableCredit(): any {
        return checkout.giftCard.credit;
    }

    get appliedCredit() {
        return checkout.giftCard.applied_credit;
    }

    private toggleModal(direction: boolean) {
        direction ? ui.openModal(this.modalId) : ui.closeModal(this.modalId);
        this.resetError();
    }

    private async getGiftCardCredit(code: string) {
        this.verified = false;
        this.applyError = '';

        const valid = await this.$validator.validateAll();
        if (!valid) {
            this.$validator.errors.all().forEach((error) => {
                this.applyError = error;
            });
            return;
        }

        this.loading = true;
        const res = await checkout.getGiftCardCredit(code);

        if (!res.err) {
            this.verified = true;
        } else {
            this.verified = false;
            this.applyError = res.err;
        }

        this.loading = false;
    }

    private async applyGiftCard(amount: any) {
        let res: boolean = false;
        this.applyError = '';

        const valid = await this.$validator.validateAll();
        if (!valid) {
            this.$validator.errors.all().forEach((error) => {
                this.applyError = error;
            });
            return;
        }

        this.loading = true;
        try {
            res = await checkout.applyGiftCard(amount);
            this.toggleModal(false);
        } catch (e) {
            this.applyError = this.$t('Cannot apply Gift Card').toString();
        }

        this.loading = false;
    }

    private async removeGiftCard() {
        let res: boolean = false;
        this.loading = true;
        this.applyError = '';

        res = await checkout.removeGiftCard();

        this.loading = false;
    }

    private resetError() {
        this.$validator.reset();
        this.applyError = '';
    }
}
